import { Form, Row } from "reactstrap";
import { useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

const CreaComentariosMenu = (props) => {
  const cookie = new Cookies();
  const [loading, setLoading] = useState({
    avanza: false,
    devuelve: false,
  });

  const Avanza = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, avanza: true }));

    try {
      const response = await axios.post(
        // eslint-disable-next-line react/prop-types
        `https://contratosback.azurewebsites.net/api/v1/EnviaPaso/${props.paso}/avanza/${props.id}`,
        {},
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        }
      );
      alert(response.data);
      window.location.reload("/");
    } catch (error) {
      console.error(error);
      alert("Error al avanzar: " + error.message);
    } finally {
      setLoading((prev) => ({ ...prev, avanza: false }));
    }
  };

  const Devuelve = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, devuelve: true }));

    try {
      const response = await axios.post(
        // eslint-disable-next-line react/prop-types
        `https://contratosback.azurewebsites.net/api/v1/EnviaPaso/${props.paso}/devuelve/${props.id}`,
        {},
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        }
      );
      alert("Devuelto con éxito");
      window.location.reload("/");
    } catch (error) {
      console.error(error);
      alert("Error al devolver: " + error.message);
    } finally {
      setLoading((prev) => ({ ...prev, devuelve: false }));
    }
  };

  const isAuthPage = window.location.href.toLowerCase().includes("autenticacion");

  return (
    <>
      <Row>
        <center>
          <Form>
            {cookie.get("tipo_Usuario") !== "6" && (
              <div>
                <h6 className="heading-small text-muted mb-3">OPCIONES</h6>

                <div className="d-flex gap-2 flex-wrap">
                  <center>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={Devuelve}
                      disabled={loading.devuelve}
                      style={{ fontSize: "12px", padding: "6px 12px" }}
                    >
                      {loading.devuelve ? "Devolviendo..." : "DEVOLVER CONTRATO"}
                    </button>
                  </center>

                  {!isAuthPage && (
                    <button
                      className="btn btn-success btn-sm"
                      onClick={Avanza}
                      disabled={loading.avanza}
                      style={{ fontSize: "12px", padding: "6px 12px" }}
                    >
                      {loading.avanza
                        ? "Enviando al siguiente aprobador..."
                        : "SIGUIENTE APROBACIÓN"}
                    </button>
                  )}
                </div>
              </div>
            )}
          </Form>
        </center>
      </Row>
    </>
  );
};

export default CreaComentariosMenu;
